import { render, staticRenderFns } from "./customer-inspection-create-wizard.vue?vue&type=template&id=13da4070&"
import script from "./customer-inspection-create-wizard.vue?vue&type=script&lang=js&"
export * from "./customer-inspection-create-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports